export default {
  steps: {
    setup_fee: 'Taxă de configurare',
    business_info: 'Informații afacere',
    create_preview: 'Creați contract de previzualizare',
    preview: 'Previzualizați contractul',
    sign: 'Semnați contractul',
  },
  buttons: {
    next: 'Previzualizați contractul',
    save_and_continue: 'Salvați și continuați',
    update: 'Actualizați previzualizarea',
    cancel: 'Anulați curentul',
    skip: 'Omiteți crearea contractului',
  },
  create_preview: {
    header: 'Creați contract de previzualizare',
    description: 'Introduceți detaliile destinatarului pentru contract. Le puteți modifica înainte de trimitere.',
  },
  sign: {
    update_notice: 'Pentru a actualiza contractul, anulați-l pe cel curent și editați detaliile.',
  },
  toasts: {
    failed_to_save_changes: 'Eroare la salvarea modificărilor',
  },
};
